export default __webpack_public_path__ + "static/media/TelegramRed.4877b85a.svg";